export { default } from './Timer'
